var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('eve-of-current-bank-profile',{attrs:{"data":_vm.data}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('soft-rate',{attrs:{"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }